import { useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useHistory } from 'react-router-dom'

import { URL_REFLECTION_COOKIE, URL_REFLECTION_COOKIE_EXPIRATION_TIME } from '@app/constants'

export const useURLReflectionCookie = () => {
  const [, setCookie] = useCookies([URL_REFLECTION_COOKIE])
  const history = useHistory()

  useEffect(() => {
    setCookie(URL_REFLECTION_COOKIE, history.location.pathname, {
      domain: window.location.hostname,
      path: '/',
      expires: new Date(new Date().getTime() + URL_REFLECTION_COOKIE_EXPIRATION_TIME)
    })

    return history.listen(location => {
      setCookie(URL_REFLECTION_COOKIE, location.pathname, {
        domain: window.location.hostname,
        path: '/',
        expires: new Date(new Date().getTime() + URL_REFLECTION_COOKIE_EXPIRATION_TIME)
      })
    })
  }, [history, setCookie])
}
